import { render, staticRenderFns } from "./transactionReason.vue?vue&type=template&id=3890b821&scoped=true"
import script from "./transactionReason.vue?vue&type=script&lang=js"
export * from "./transactionReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3890b821",
  null
  
)

export default component.exports